import React from "react";
import dynamic from "next/dynamic";
import ScrollSpyCy from "./ScrollSpyCy";
import StructuredData from "../StructuredData";
import { structuredData } from "@/data/structuredData";
const Layout = dynamic(() => import("@/components/Layout"));
export default function L1TemplateC({
  ServiceLevel1SEO,
  ServiceBanner,
  WhyCubetFor,
  OurServices,
  serviceLevels,
  refresh,
  WhyChooseUs,
  Slug,
  Categories,
  width,
  MainTitle
}: any) {
  const updatedL1Service1 = {
    ...structuredData.l1Service1,
    name: MainTitle,  // Dynamic title
    url: `${process.env.NEXT_PUBLIC_BASE_URL}/services/${Slug}/`,
    description: ServiceLevel1SEO?.MetaDescription,  // Dynamic description
    image: ServiceBanner?.Banner?.data?.attributes?.url,

    mainEntity: {
      ...structuredData.l1Service1.mainEntity,
      name: MainTitle,  // Dynamic mainEntity title
      serviceType: ServiceBanner?.Title,  // Dynamic serviceType
    }
  };

  const updatedL1Service2 = {
    ...structuredData.l1Service2,
    itemListElement: structuredData.l1Service2.itemListElement.map((item, index) => {
      if (index === 1) { // Position 2
        return {
          ...item,
          item: {
            ...item.item,
            "@id": `${process.env.NEXT_PUBLIC_BASE_URL}/services/${Slug}/`,
            name: MainTitle || "Default Service Title", // Dynamic title
          },
        };
      }
      return item;
    }),
  };
  return (
    <Layout
      title={ServiceLevel1SEO?.MetaTitle}
      description={ServiceLevel1SEO?.MetaDescription}
      ogTitle={ServiceLevel1SEO?.OGTitle}
      ogDescription={ServiceLevel1SEO?.OGDescription}
      footerType="banner"
      banner={true}
      // menuType="transparent" absolute={false}
      notFixedHeader={true}
      ribbonHide={true}
    >
      <StructuredData
        data={[updatedL1Service1, updatedL1Service2, structuredData.l1Service3]}
      />
      <ScrollSpyCy
        WhyChooseUs={WhyChooseUs}
        categoryId={serviceLevels?.id}
        refresh={refresh}
        ServiceBanner={ServiceBanner}
        slug={Slug}
        categories={Categories?.data}
        width={width}
        WhyCubetFor={WhyCubetFor}
        OurServices={OurServices}
        template={"C"}
      />
    </Layout>
  );
}
